export const BUTTON_MODS = {
  NAVBAR: "navbar",
} as const;
